export default {
    methods: {
        criarFiltroBuscaProjetos ({
            situacao = null}) {
            return {
                filtro: {
                    situacao: situacao,
                }
            }
        }
    },
}
